import triangleLoader from '@/assets/branding/triangles-loader.gif';

type Props = {
  className?: string;
};

export default function Loader({ className }: Props) {
  return <img className={className} src={triangleLoader} alt="-" />;
}
